module.exports = __webpack_public_path__ + "img/RJC_LP_rjc.7f2dc11.webp";